import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { LegalDocumentsTemplateService } from './legal-documents-template.service';

const service = new LegalDocumentsTemplateService();

export interface LegalDocumentsTemplateState {}

const LegalDocumentsTemplateStore: Module<LegalDocumentsTemplateState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getLegalDocumentsTemplate(context, query?: LocationQuery) {
         return await service.getLegalDocumentsTemplates(query);
      },
   },
};

export default LegalDocumentsTemplateStore;
